import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { statusService } from '../services/statusService';
import Loading from '../components/common/Loading';
import StatusUpdatesTable from '../components/common/StatusUpdatesTable';

const MyStatusPage = () => {
  const { user } = useAuth();
  const [statusUpdates, setStatusUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateFilter, setDateFilter] = useState({
    startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], // Last 30 days
    endDate: new Date().toISOString().split('T')[0]
  });
  const [filterPriority, setFilterPriority] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  const loadMyStatus = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        userId: user.id,
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate
      };

      const response = await statusService.getStatusUpdates(params);
      setStatusUpdates(response.data || []);
    } catch (error) {
      console.error('Failed to load my status:', error);
    } finally {
      setLoading(false);
    }
  }, [user.id, dateFilter]);

  useEffect(() => {
    loadMyStatus();
  }, [loadMyStatus]);

  const filteredUpdates = statusUpdates.filter(update => {
    const matchesPriority = !filterPriority || update.task?.priority === filterPriority;
    const matchesStatus = !filterStatus || update.status === filterStatus;

    return matchesPriority && matchesStatus;
  });

  const handleDateRangeChange = (field, value) => {
    setDateFilter(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (loading) return <Loading />;

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-4">My Tasks & Updates</h1>
        <p className="text-gray-600 mb-4">View all your submitted status updates and tasks</p>
        
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
            <input
              type="date"
              value={dateFilter.startDate}
              onChange={(e) => handleDateRangeChange('startDate', e.target.value)}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
            <input
              type="date"
              value={dateFilter.endDate}
              onChange={(e) => handleDateRangeChange('endDate', e.target.value)}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
            <select
              value={filterPriority}
              onChange={(e) => setFilterPriority(e.target.value)}
              className="w-full border rounded px-3 py-2"
            >
              <option value="">All Priorities</option>
              <option value="P1">P1 - Critical</option>
              <option value="P2">P2 - High</option>
              <option value="P3">P3 - Medium</option>
              <option value="P4">P4 - Low</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="w-full border rounded px-3 py-2"
            >
              <option value="">All Statuses</option>
              <option value="Not Started">Not Started</option>
              <option value="Planning">Planning</option>
              <option value="In Progress">In Progress</option>
              <option value="In Review">In Review</option>
              <option value="Blocked">Blocked</option>
              <option value="On Hold">On Hold</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>

        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          
        </div>
      </div>

      <div className="mb-4 text-sm text-gray-600">
        Showing {filteredUpdates.length} of {statusUpdates.length} status updates
      </div>

      <StatusUpdatesTable updates={filteredUpdates} showUserColumn={false} />
    </div>
  );
};

export default MyStatusPage;
